<script setup lang="ts">
import type { CheckoutView } from 'types/checkout'

type NavigationViews = 'cart' | 'address' | 'payment'
const views: NavigationViews[] = ['cart', 'address', 'payment']

const cartStore = useCartStore()
const checkoutStore = useCheckoutStore()
const { state } = storeToRefs(cartStore)
const { completedViews } = storeToRefs(checkoutStore)
const route = useRoute()

function isValid(view: CheckoutView) {
  return computed(() => {
    switch (view) {
      case 'cart':
        return true
      case 'address':
        return state.value.items.length > 0 && completedViews.value.includes('cart')
      case 'payment':
        return state.value.items.length > 0 && completedViews.value.includes('address')
    }
  })
}
</script>

<template>
  <nav
    class="checkout-nav"
    :aria-label="$t('checkOut')"
  >
    <ol>
      <li
        v-for="view in views"
        :key="view"
      >
        <NuxtLink
          v-if="isValid(view).value"
          :to="$checkoutUrl({ route, view })"
        >
          <span>{{ $t(view) }}</span>
        </NuxtLink>
        <p v-else>
          <span>{{ $t(view) }}</span>
        </p>
      </li>
    </ol>
  </nav>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';

.payment .checkout-nav {
  padding: 1.5rem 0;
}

nav {
  display: grid;
  place-items: center;
}

ol {
  width: 100%;
  height: 100%;
  display: grid;
  padding: 0 2rem;
  max-width: 50rem;
  align-items: center;
  grid-auto-flow: column;
}

li {
  text-align: center;

  &.success {
    display: none;
    visibility: hidden;
  }
}

li > a,
li > p {
  position: relative;
  font-size: 1.4rem;
  color: var(--black);
  line-height: 1.6rem;
  text-transform: capitalize;
  transition: all ease-in-out 0.2s;
  padding: 1.5rem;
  &:focus-visible {
    outline: 2px solid var(--black);
    outline-offset: 2px;
  }

  &.router-link-active {
    text-decoration: underline;
    text-decoration-style: wavy;
    text-decoration-color: var(--black);
    text-underline-offset: 0.5rem;
    text-decoration-thickness: 0.15rem;
  }
}

li > p {
  cursor: unset;
  color: var(--gray-inactive);
}

@media (min-width: $tablet) {
  button {
    font-size: 1.8rem;
    line-height: 1.8rem;
  }
}
</style>
